import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { procentaRegExp, procentaRegExp6 } from 'enums/regExp';

export const procentaValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || procentaRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_PROCENTA_100_0</TranslateText>);
        }
    })
];

export const procentaValidation6 = (zeroAllowed?: boolean) => [
    () => ({
        validator(_rule: RuleObject, value: string | number) {
            if (!zeroAllowed && (value || value === 0) && Number(value) <= 0) {
                return Promise.reject(<TranslateText>NEVALIDNI_PROCENTA_100_06_0</TranslateText>);
            }
            if (!value || procentaRegExp6.test(String(value))) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_PROCENTA_100_06</TranslateText>);
        }
    })
];

export default procentaValidation;
